module.exports = __webpack_public_path__ + "static/media/scratch-off-qrc-one.a9874287.svg";